import { render, staticRenderFns } from "./AuthStatus.vue?vue&type=template&id=c94b91d2&scoped=true&"
import script from "./AuthStatus.vue?vue&type=script&lang=ts&"
export * from "./AuthStatus.vue?vue&type=script&lang=ts&"
import style0 from "./AuthStatus.vue?vue&type=style&index=0&id=c94b91d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94b91d2",
  null
  
)

export default component.exports